import { render } from "./PalletLabel.vue?vue&type=template&id=7fa63fe8&scoped=true"
import script from "./PalletLabel.vue?vue&type=script&lang=js"
export * from "./PalletLabel.vue?vue&type=script&lang=js"

import "./PalletLabel.vue?vue&type=style&index=0&id=7fa63fe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa63fe8"]])

export default __exports__